<template>
  <svg
    :width="size"
    :height="size"
    :fill="overrideFill || fill"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
    class="fluent-icon"
  >
    <path
      v-for="(source, idx) in pathSource"
      :key="source"
      :d="source"
      :fill="!idx ? overrideFill || fill : 'currentColor'"
    />
  </svg>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    fill: {
      type: String,
      default: 'currentColor',
    },
    overrideFill: {
      type: String,
      default: null,
    },
  },

  computed: {
    pathSource() {
      const path = this.icons[`${this.icon}-${this.type}`];
      return Array.isArray(path) ? path : [path];
    },
  },
};
</script>
